<template>
  <el-container
    v-loading="$store.state.aws_loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <el-aside v-if="pc_app == 'pc'" width="320">
      <!-- <Sidebar :authjson="authjson"/> -->
      <Sidebar />
    </el-aside>

    <el-aside v-if="pc_app == 'app'" width="320">
      <!-- <button @click="drawer=!drawer ">11</button> -->
      <!-- 抽屉 弹框 -->
      <el-drawer
        :with-header="false"
        size="320px"
        :visible.sync="drawer"
        direction="ltr"
      >
        <Sidebar />
      </el-drawer>
    </el-aside>

    <el-container>
      <el-header height="80px">
        <!-- <Header :user_img_url="user_img_url" /> -->
        <Header />
      </el-header>
      <el-main ref="body_box">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getUserInfo } from "@/api/api";
export default {
  components: {
    Header: () => import("./components/header.vue"),
    Sidebar: () => import("./components/sidebar.vue"),
  },
  data() {
    return {
      pc_app: this.pcormove._isMobile(),
      drawer: false,
      user_img_url: "",
      authjson: [],
    };
  },
  created() {},
  mounted() {
    this.bus.$on("app_sidebar_open", () => {
      this.drawer = true;
    });

    // 路由切换 返回顶部
    this.$router.afterEach((to, from, next) => {
      to;
      from;
      next;
      this.$nextTick(() => {
        if (
          this.$refs &&
          this.$refs.body_box &&
          this.$refs.body_box.$el &&
          this.$refs.body_box.$el.scrollTop
        ) {
          this.$refs.body_box.$el.scrollTop = 0;
          // console.log(this.$refs.body_box.$el.scrollTop);
        }
      });
    });

    // 页面 滚动最底部
    this.bus.$on("scroll_set", () => {
      this.$refs.body_box.$el.scrollTop = this.$refs.body_box.$el.scrollHeight;
    });

    // 页面 滚动一定距离
    this.bus.$on("scroll_set_num", (v) => {
      this.$refs.body_box.$el.scrollTop = v;
    });

    this.bus.$on("user_data", (v) => {
      v;
      // console.log(v);
      this.get_user_info();
    });
    this.get_user_info();
  },
  methods: {
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          // this.user_img_url=res.data.data.avatar;
          sessionStorage.setItem("avatar", res.data.data.avatar);
          localStorage.setItem("approve_status", res.data.data.approve_status);
          // 头像
          // console.log(res.data.data);

          // 2023-06-08
          // company_type 0 链接申请卡正常显示 1去掉card-name等字段
          sessionStorage.setItem("company_type", res.data.data.company_type);
          this.$nextTick(function () {
            sessionStorage.setItem("company_type", res.data.data.company_type);
          });

          // change_kyc_switch:1/0,//修改kyc开关;1开;0关
          sessionStorage.setItem(
            "change_kyc_switch",
            res.data.data.change_kyc_switch
          );

          // haveContract 是否有合同
          const haveContract = res.data.data.haveContract;
          haveContract && sessionStorage.setItem("haveContract", haveContract);

          // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
          // 4审核通过 路由才能跳转
          sessionStorage.setItem("kyc_status", res.data.data.kyc_status);
          sessionStorage.setItem("project_name", res.data.data.project_name);
          //邮箱
          sessionStorage.setItem("u_email", res.data.data.email);
          if (res.data.data.userType == 1) {
            this.authjson = [
              "1",
              "1-1",
              "1-2",
              "1-3",
              "1-4",
              "2",
              "2-1",
              "2-2",
              "2-3",
              "2-4",
              "2-5",
              "2-6",
              "3",
              "3-1",
              "3-2",
              "3-3",
              "3-4",
              "3-5",
              "3-6",
              "3-7",
              "4",
              "4-1",
              "4-2",
              "4-3",
              "4-4",
              "4-5",
              "4-6",
              "4-7",
              "4-8",
              "5",
              "6",
              "7",
              "8",
              "9",
              "9-1",
              "9-2",
              "9-3",
              "9-4",
              "9-5",
              "9-6",
              "9-7",
              "9-8",
              "9-9",
              "9-10",
              "9-11",
              "9-12",
              "9-13",
              "9-14",
              "9-15",
              "9-16",
              "9-17",
              "9-18",
              "9-19",
              "10",
              "11",
              "11-1",
              "11-2",
              "11-3",
              "11-4",
              "11-5",
              "11-6",
              "11-7",
              "11-8",
              "11-9",
              "11-10",
              "12",
              "12-1",
              "12-2",
              "12-3",
              "12-4",
              "12-5",
              "13",
              "13-1",
              "13-2",
              "13-3",
              "13-4",
              "13-5",
              "13-6"
            ];
            sessionStorage.setItem("authjson", JSON.stringify(this.authjson));
          } else {
            this.authjson = res.data.data.authjson;
            sessionStorage.setItem(
              "authjson",
              JSON.stringify(res.data.data.authjson)
            );
          }
          localStorage.setItem("userid", res.data.data.userid);
        }
      });
    },
  },
  destroyed() {
    this.bus.$off("app_sidebar_open");
    this.bus.$off("scroll_set");
    this.bus.$off("scroll_set_num");
    this.bus.$off("user_data");
  },
  watch: {
    $route() {
      this.drawer = false;
    },
  },
};
</script>

<style scoped>
.el-header {
  padding: 0 !important;
}
.el-main {
  height: calc(100vh - 80px);
  overflow: auto;
  /* overflow-y: hidden; */
  background: #041e35;
  color: #fff;
  box-sizing: border-box;
  padding: 40px;
  padding-top: 20px;
}
.el-main::-webkit-scrollbar {
  /* width: 8px; */
  width: 5px;
}
.el-main::-webkit-scrollbar-thumb {
  border-radius: 5px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  /* background: #687eec;#F1C788 */
  background: #f1c788;
}

/* 手机端 */
@media screen and (max-width: 850px) {
  .el-main {
    overflow-y: auto;
    padding: 20px;
  }
}
</style>
